/*
	This module is solely a pass-through for webpack to pick the right config
	file based on the build being run. The string "CONFIG_TARGET" below will
	be replaced with "local", "dev", "test" or "prod". Please do not add any
	other config values here, as they belong in the files in the config/ folder.
*/
import targetConfig from "../config/config.CONFIG_TARGET.js";
import storage from "@teaming/common-storage";

const configOverride = storage.getConfigOverride();

const config = Object.freeze( {
	termsLink: "https://www.teaming.com/terms-of-service/",
	policyLink: "https://www.teaming.com/privacy-policy/",
	routeTitlePrefix: "Teaming |",
	routeTitlePostfix: "| Teaming",
	...targetConfig,
	...configOverride,
} );

export default config;
